import { useLocalSearchParams } from 'expo-router';

import { DeferredRedirect } from '../../../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const params = useLocalSearchParams<{ assetId: string }>();

  return <DeferredRedirect href={{ pathname: '/account/gift/checkout/[assetId]', params }} />;
}
